// Product comparison tray (Phase 7 7H; T63: items keep name / price / thumbnail so the tray shows real products). localStorage, max 4.
const KEY = "rst_compare";
const MAX = 4;
const emit = (name, detail) => window.dispatchEvent(new CustomEvent(name, { detail }));
const pretty = (slug) => slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
const meta = (p) => (typeof p === "string" ? { slug: p } : { slug: p.slug, name: p.display_name || p.name, price: p.price_inc_gst ?? p.price ?? null, media_id: p.primary_media_id ?? p.media_id ?? null });

export function getCompare() {  // [{ slug, name, price, media_id }]
  try {
    return (JSON.parse(localStorage.getItem(KEY)) || []).map((x) => (typeof x === "string" ? { slug: x } : x)).filter((x) => x?.slug).slice(0, MAX);
  } catch { return []; }
}
const save = (items) => { localStorage.setItem(KEY, JSON.stringify(items)); emit("compare-changed"); return items; };
export const compareSlugs = () => getCompare().map((x) => x.slug);
export const itemName = (x) => x.name || pretty(x.slug);
export const isInCompare = (slug) => compareSlugs().includes(slug);

// "added" | "removed" | "full" - the tray listens for compare-added / compare-full (non-blocking feedback; full opens the tray to swap)
export function addCompare(p) {
  const m = meta(p), cur = getCompare();
  if (cur.some((x) => x.slug === m.slug)) return "exists";
  if (cur.length >= MAX) { emit("compare-full", m); return "full"; }
  save([...cur, m]);
  emit("compare-added", { item: m, count: cur.length + 1 });
  return "added";
}
export function removeCompare(slug) { save(getCompare().filter((x) => x.slug !== slug)); return "removed"; }
export const toggleCompare = (p) => (isInCompare(typeof p === "string" ? p : p.slug) ? removeCompare(typeof p === "string" ? p : p.slug) : addCompare(p));
export function updateCompareMeta(products) {  // fill in names / prices for items saved before T63
  const by = Object.fromEntries(products.map((p) => [p.slug, meta(p)]));
  const cur = getCompare();
  if (cur.some((x) => by[x.slug] && (!x.name || x.price !== by[x.slug].price || x.media_id !== by[x.slug].media_id))) save(cur.map((x) => by[x.slug] || x));
}
export function clearCompare() { localStorage.removeItem(KEY); emit("compare-changed"); }
export const openCompareTray = () => emit("compare-open");
export const COMPARE_MAX = MAX;
// T74: compare from chat - replace the list with these, or add as many as fit (max 4)
export const setCompareList = (ps) => save(ps.slice(0, MAX).map(meta));
export function addCompareMany(ps) {
  const cur = getCompare(), have = new Set(cur.map((x) => x.slug));
  const add = ps.map(meta).filter((m) => !have.has(m.slug)), room = Math.max(0, MAX - cur.length);
  save([...cur, ...add.slice(0, room)]);
  return { added: Math.min(room, add.length), left: Math.max(0, add.length - room) };
}
// T74: the assistant panel hides the separate compare bar while it is open (it shows its own compact strip instead)
export const assistantIsOpen = () => !!window.__rstAsstOpen;

// T71: listing-level compare mode (tiles show the compare toggle only while it is on). Session-scoped; stays on while items are in the list.
const MODE = "rst_compare_mode";
export const compareModeOn = () => sessionStorage.getItem(MODE) === "1" || getCompare().length > 0;
export const setCompareMode = (on) => { if (on) sessionStorage.setItem(MODE, "1"); else sessionStorage.removeItem(MODE); emit("compare-mode-changed"); };
